/**
 * @Author: wuyang
 * @Date: 2024/1/10
 * @Description: ""
 */
import { MenuProps, Avatar, Divider, Dropdown, theme, message, Modal, Button, Space, Input } from 'antd'
import {
	AccountBookOutlined,
	LogoutOutlined,
	SketchOutlined,
	UserOutlined,
	LockOutlined,
	ControlOutlined,
	TeamOutlined,
	ThunderboltOutlined,
	UserSwitchOutlined,
	SwapOutlined,
	CheckOutlined,
	CaretDownOutlined
} from '@ant-design/icons'
import React, { useState, useEffect } from 'react'
import { userinfoService } from '@/common/services/userinfo/userinfoService'
import { useNavigate } from 'react-router-dom'
import { useAtomMethod } from '@/helper/hooks/atom-method-hook/useAtomMethod'
import ModalChangePassword from '../../pages/change/ModalChangePassword'
import { updatePasswordByOld, createTeam, switchTeamMode } from '@/api/login'
import { BASE_URL } from '@/constant'
import dayjs from 'dayjs'

const { useToken } = theme

const isPasswordRemindExpired = (userInfo: any) => {
	if (!userInfo?.isPassword || !userInfo?.passwordUpdateTime || !userInfo?.passwordRemindDays) {
		return false
	}

	const passwordUpdateTime = dayjs(userInfo.passwordUpdateTime)
	const passwordRemindDays = Number(userInfo.passwordRemindDays)
	if (!passwordUpdateTime.isValid() || !Number.isFinite(passwordRemindDays) || passwordRemindDays <= 0) {
		return false
	}

	return dayjs().valueOf() >= passwordUpdateTime.add(passwordRemindDays, 'day').valueOf()
}

export const DataXHeaderAvatar = () => {
	const { token } = useToken()
	const navigate = useNavigate()
	const [useInfo] = useAtomMethod(userinfoService.userInfo)
	const [loginToken] = useAtomMethod(userinfoService.token)
	const [isVip] = useAtomMethod(userinfoService.isVip)
	const [messageApi, messageContextHolder] = message.useMessage()
	const [modal, contextHolder] = Modal.useModal()

	const [teamMode, setTeamMode] = useState(useInfo?.currentMode || 1);// 当前是个人还是团队(1:个人 2:团队)

	useEffect(() => {
		if (useInfo?.currentMode) {
			setTeamMode(useInfo.currentMode);
		}
	}, [useInfo?.currentMode]);

	const items: MenuProps['items'] = [
		// {
		// 	key: 'platform',
		// 	icon: <ControlOutlined />,
		// 	label: <span>平台配置</span>,
		// 	onClick: () => {
		// 		navigate('/platformConfig')
		// 	}
		// },
		{
			key: 'vip',
			icon: <SketchOutlined />,
			label: <span>会员中心</span>,
			onClick: () => {
				navigate('/vip')
				// window.open('/vip')

				// userinfoService.login()
			}
		},
		{
			key: 'order',
			icon: <AccountBookOutlined />,
			label: <span>我的订单</span>,
			onClick() {
				navigate('/order')
			}
		},
		{
			type: 'divider'
		},
		// {
		// 	key: 'unbindWX',
		// 	icon: <ApiOutlined />,
		// 	label: <span>解绑微信</span>,
		// 	onClick() {
		// 		delUserOpenId({
		// 			openId: userinfoService.openId.get()
		// 		}).then((res) => {
		// 			userinfoService.logout()
		// 			navigate('/login')
		// 		})
		// 	}
		// },
		...(teamMode === 2 ? [
			{
				key: 'memberManagement',
				icon: <UserSwitchOutlined />,
				label: <span>成员管理</span>,
				onClick: () => {
					navigate('/memberManagement')
				}
			},
			{
				key: 'teamInfo',
				icon: <TeamOutlined />,
				label: <span>团队信息</span>,
				onClick: () => {
					navigate('/teamInfo')
				}
			},
		] : []),
		{
			key: 'personalInfo',
			icon: <UserOutlined />,
			label: <span>个人信息</span>,
			onClick: () => {
				navigate('/personalInfo')
			}
		},
		{
			key: 'integralDetail',
			icon: <ThunderboltOutlined />,
			label: <span>积分明细</span>,
			onClick: () => {
				navigate('/integralDetail')
			}
		},
		{
			type: 'divider'
		},
		{
			key: 'handle',
			icon: <LockOutlined />,
			label: <span>设置密码</span>,
			onClick: () => {
				setVisible(true)
			}
		},
		{
			key: 'logout',
			icon: <LogoutOutlined />,
			label: <span>退出登录</span>,
			onClick() {
				userinfoService.logout()
				navigate('/login')
			}
		}
	]
	const [visible, setVisible] = useState(false)

	// 根据用户信息中的 isPassword 控制弹窗显示
	useEffect(() => {
		if (localStorage.getItem('firstTip') === 'first' && useInfo && useInfo.isPassword === false) {
			message.open({
				type: 'warning',
				content:
					'欢迎登录！请设置登录密码，方便以后使用账号密码登录',
				duration: 6
			})
			setVisible(true)
			localStorage.removeItem('firstTip')
		}
	}, [useInfo, useInfo?.isPassword])

	useEffect(() => {
		if (!loginToken || !isPasswordRemindExpired(useInfo)) {
			return
		}

		const remindKey = `password-remind-modal:${[
			loginToken,
			useInfo?.userId,
			useInfo?.passwordUpdateTime,
			useInfo?.passwordRemindDays
		].join('-')}`

		if (sessionStorage.getItem(remindKey)) {
			return
		}
		sessionStorage.setItem(remindKey, '1')

		modal.confirm({
			title: '账号校验周期已到期',
			content: '您的账号已到达固定校验周期，请及时修改密码。',
			okText: '去修改密码',
			cancelText: '稍后处理',
			centered: true,
			onOk: () => {
				setVisible(true)
			}
		})
	}, [loginToken, modal, useInfo, useInfo?.isPassword, useInfo?.passwordRemindDays, useInfo?.passwordUpdateTime, useInfo?.userId])

	const handleCancel = () => {
		setVisible(false)
	}
	// 确认设置密码
	const handleOk = (val: any) => {
		const userId = userinfoService.userInfo.get()?.userId
		updatePasswordByOld({
			oldPassword: val.oldPassword || '',
			newPassword: val.newPassword || '',
			userId: userId ? userId : '',
			passwordRemindDays: val.passwordRemindDays || 90
		}).then((res) => {
			messageApi.success(`密码设置成功!`)
			setVisible(false)
			userinfoService.refresh()
		}).catch((err) => {
			messageApi.warning(err.data?.msg || err?.msg)
		})
	}

	const contentStyle: React.CSSProperties = {
		backgroundColor: token.colorBgElevated,
		borderRadius: token.borderRadiusLG,
		boxShadow: token.boxShadowSecondary
	}

	const menuStyle: React.CSSProperties = {
		boxShadow: 'none'
	}

	const handleSwitchMode = async (teamId: number) => {
		const newMode = teamId === 0 ? 1 : 2;
		setTeamMode(newMode);

		try {
			await switchTeamMode({ teamId });
			messageApi.success('切换成功');
			userinfoService.refresh() // 添加刷新团队信息
			setSwitchModalVisible(false);

			// 检查当前路由，如果是成员管理或团队信息或团队工具或批量裂变页面则跳转首页
			const currentPath = window.location.pathname;
			if (newMode === 1 && (currentPath.includes('/memberManagement') || currentPath.includes('/teamInfo') || currentPath.includes('/teamTools') || currentPath.includes('/batchTools'))) {
				navigate('/');
			}
		} catch (err: any) {
			messageApi.error(`切换团队失败：${err?.msg || err?.data?.msg || '未知错误'}`);
			// 回滚时也从服务端获取最新状态
			const latestMode = userinfoService.userInfo.get()?.currentMode || 1;
			setTeamMode(latestMode);
		}
	};

	const [switchModalVisible, setSwitchModalVisible] = useState(false);
	const [createModalVisible, setCreateModalVisible] = useState(false);

	const industryItems = [
		{
			label: '电商行业', key: '1', subItems: [
				{ label: '电商设计师', key: '电商设计师' },
				{ label: '电商美工', key: '电商美工' },
				{ label: 'UI/UX设计师', key: 'UI/UX设计师' },
				{ label: '电商产品设计', key: '电商产品设计' },
				{ label: '其他', key: '其他' },
			]
		},
		{
			label: '互联网行业', key: '2', subItems: [
				{ label: 'UI设计师', key: 'UI设计师' },
				{ label: '平面设计师', key: '平面设计师' },
				{ label: '互联网运营', key: '互联网运营' },
				{ label: '自媒体运营', key: '自媒体运营' },
				{ label: '其他', key: '其他' },
			]
		},
		{
			label: '摄影行业', key: '3', subItems: [
				{ label: '摄影师', key: '摄影师' },
				{ label: '后期修图师', key: '后期修图师' },
			]
		},
		{
			label: '时尚行业', key: '4', subItems: [
				{ label: '时装设计师', key: '时装设计师' },
				{ label: '配饰设计师', key: '配饰设计师' },
			]
		},
		{
			label: '游戏行业', key: '5', subItems: [
				{ label: '游戏设计师', key: '游戏设计师' },
				{ label: '原画设计师', key: '原画设计师' },
				{ label: '独立游戏制作者', key: '独立游戏制作者' },
				{ label: '动画师', key: '动画师' },
			]
		},
		{
			label: '插画设计', key: '6', subItems: [
				{ label: '自由职业插画师', key: '自由职业插画师' },
				{ label: '儿童图书插画师', key: '儿童图书插画师' },
				{ label: '漫画家/动画师', key: '漫画家/动画师' },
				{ label: '包装设计师', key: '包装设计师' },
				{ label: '绘本设计', key: '绘本设计' },
				{ label: '文创设计', key: '文创设计' },
				{ label: 'IP设计', key: 'IP设计' },
			]
		},
		{
			label: '广告行业', key: '7', subItems: [
				{ label: '平面设计师', key: '平面设计师' },
				{ label: '3D视觉设计师', key: '3D视觉设计师' },
				{ label: '动画师/动态图形设计师', key: '动画师/动态图形设计师' },
				{ label: '其他', key: '其他' },
			]
		},
		{
			label: '教育行业', key: '8', subItems: [
				{ label: '儿童教育', key: '儿童教育' },
				{ label: '成人Ai教育', key: '成人Ai教育' },
			]
		},
		{
			label: '内容创作者', key: '9', subItems: [
				{ label: '自由创作人', key: '自由创作人' },
				{ label: '小红书博主', key: '小红书博主' },
				{ label: '短视频博主', key: '短视频博主' },
			]
		},
	]


	const [selectedIndustry, setSelectedIndustry] = useState('') // 状态管理选中的行业

	const handleMenuClick = (e: { key: string }) => {
		const selectedItem: any = items.find((item: any) => item.key === e.key)
		if (selectedItem) {
			setSelectedIndustry(selectedItem.label)
			console.log(selectedItem.label, "选择的行业")
		}
	}
	const [selectedCareer, setSelectedCareer] = useState('') // 状态管理选中的行业
	const handleCareerClick = (e: { key: string }) => {
		if (!selectedIndustry) {
			messageApi.warning('请先选择行业');
			return;
		}
		setSelectedCareer(e.key);
		console.log('选择的职业:', e.key);
	}

	const getCareerItems = () => {
		if (!selectedIndustry) return [];
		const industry: any = items.find((item: any) => item.label === selectedIndustry);
		return industry?.subItems || [];
	}
	const [nickname, setNickname] = useState('');
	const [teamName, setTeamName] = useState('');

	const handleCreate = async () => {
		if (!teamName.trim()) {
			messageApi.warning('请填写团队名称');
			return;
		}
		if (!nickname.trim()) {
			messageApi.warning('请填写昵称');
			return;
		}
		try {
			await createTeam({
				nickname,
				teamName,
				industry: selectedIndustry,
				profession: selectedCareer,
			});
			messageApi.success('创建团队成功');
			setCreateModalVisible(false);
			setSwitchModalVisible(false);
			userinfoService.refresh() // 添加刷新团队信息
		} catch (err: any) {
			messageApi.error(`创建团队失败：${err?.msg || err?.data?.msg || ''}`);
		}
	};
	return (
		<>
			{/* 切换团队弹窗 start */}
			<Modal
				title='切换团队'
				open={switchModalVisible}
				onCancel={() => {
					setSwitchModalVisible(false);
				}}
				footer={null}
				centered
			>
				<p className='text-[#666]'>个人</p>
				<div className='flex justify-between items-center p-2 mt-4 mb-4 hover:bg-[#eee]' onClick={() => { handleSwitchMode(0) }}>
					<div className='flex items-center'>
						<div className='mr-[16px]'>
							{
								useInfo?.avatar ? (
									<img
										className="avatar-image cursor-pointer w-[48px] h-[48px] rounded-full block"
										src={`${BASE_URL}${useInfo?.avatar}`}
									/>
								) : (
									<Avatar
										className={'cursor-pointer bg-primary'}
										size={48}
										icon={<UserOutlined />}
									/>
								)
							}
						</div>
						<div>
							<p className='text-[16px] font-bold mb-2'>{useInfo?.nickName}</p>
							<p className='text-[#888] '>我自己</p>
						</div>
					</div>
					{teamMode == 1 && (<CheckOutlined className='text-[green] text-[22px]' />)}
				</div>
				<p className='text-[#666]'>团队</p>
				{useInfo?.teamId == 0 ? (
					<div className='flex justify-center items-center mt-4 mb-4'>
						<Button type='primary' size='large' onClick={() => {
							setCreateModalVisible(true);
							setNickname('');
							setTeamName('');
							setSelectedIndustry('');
							setSelectedCareer('');
						}}>
							创建团队
						</Button>
					</div>
				) : (
					<div className='flex justify-between items-center p-2 mt-4 mb-4 hover:bg-[#eee]' onClick={() => { handleSwitchMode(useInfo?.teamId || 0) }}>
						<div className='flex items-center'>
							<div className='mr-[16px]'>
								{
									useInfo?.team?.avatar ? (
										<img
											className="avatar-image cursor-pointer w-[48px] h-[48px] rounded-full block"
											src={`${BASE_URL}${useInfo?.team?.avatar}`}
										/>
									) : (
										<Avatar
											className={'cursor-pointer bg-primary'}
											size={48}
											icon={<TeamOutlined />}
										/>
									)
								}
							</div>
							<p className='text-[16px] font-bold'>{useInfo?.team?.teamName}</p>
						</div>
						{teamMode == 2 && (<CheckOutlined className='text-[green] text-[22px]' />)}
					</div>
				)}

			</Modal>
			{/* 切换团队弹窗 end */}
			{/* 创建团队弹窗 start */}
			<Modal
				title=''
				width={800}
				open={createModalVisible}
				onCancel={() => {
					setCreateModalVisible(false);
				}}
				footer={null}
				centered
			>
				<img className={'w-full '} src={require(`@/asset/image/creatTeam.png`)} alt="" />
				<div className='flex justify-center items-center mt-[76px] mb-[110px]'>
					<img
						className={'w-[180px] h-[180px]  mr-[142px] rounded-[4px]'}
						src={require(`@/asset/icon/cut-active.webp`)}
						alt=""
					/>
					<div>
						<p className='font-bold text-[16px]'>团队名称</p>
						<Input placeholder="请输入团队名称" variant="underlined" style={{ padding: '2px 0', fontSize: '16px', fontWeight: 'bold', borderBottom: '1px solid #1a1a1a' }} value={teamName} onChange={(e) => setTeamName(e.target.value)} />
						<p className='font-bold mt-[16px] text-[16px]'>我在团队中的称呼</p>
						<Input placeholder="请输入我在团队中的称呼" variant="underlined" style={{ padding: '2px 0', fontSize: '16px', fontWeight: 'bold', borderBottom: '1px solid #1a1a1a' }} value={nickname} onChange={(e) => setNickname(e.target.value)} />
						<p className='font-bold mt-[16px] text-[16px]'>所属行业</p>
						<Input placeholder="请输入所属行业" variant="underlined" style={{ padding: '2px 0', fontSize: '16px', fontWeight: 'bold', borderBottom: '1px solid #1a1a1a' }} value={selectedIndustry} onChange={(e) => setSelectedIndustry(e.target.value)} />
						<p className='font-bold mt-[16px] text-[16px]'>我的职业</p>
						<Input placeholder="请输入我的职业" variant="underlined" style={{ padding: '2px 0', fontSize: '16px', fontWeight: 'bold', borderBottom: '1px solid #1a1a1a' }} value={selectedCareer} onChange={(e) => setSelectedCareer(e.target.value)} />
						{/* <div className='mt-[16px] mb-[16px] cursor-pointer'>
							<Dropdown menu={{ items: industryItems, onClick: handleMenuClick }}>
								<p onClick={(e) => e.preventDefault()}>
									<Space>
										所属行业
										<CaretDownOutlined style={{ color: '#999' }} />
									</Space>
									<p className='text-[16px]'> {selectedIndustry || '暂未选择'}</p>
								</p>
							</Dropdown>
						</div>
						<div className='cursor-pointer'>
							<Dropdown menu={{ items: getCareerItems(), onClick: handleCareerClick }}>
								<p onClick={(e) => {
									e.preventDefault();
									if (!selectedIndustry) {
										messageApi.warning('请先选择所属行业');
									}
								}}>
									<Space>
										我的职业
										<CaretDownOutlined style={{ color: '#999' }} />
									</Space>
									<p className='text-[16px]'> {selectedCareer || '暂未选择'}</p>
								</p>
							</Dropdown>
						</div> */}
					</div>
				</div>
				<div className='w-full h-[60px] text-[32px] text-[#fff] bg-primary text-center cursor-pointer' style={{ lineHeight: '60px' }} onClick={handleCreate}>创建并进入</div>
			</Modal >
			{/* 创建团队弹窗 end */}
			<Dropdown
				menu={{ items }
				}
				arrow
				popupRender={(menu) => (
					<div style={contentStyle} className={'w-[140px]'}>
						<div className={'p-2 pl-4 '}>
							<div className={'text-[16px]'}>{useInfo?.phone}</div>
							<div className={'flex mt-1 mb-1 '}>
								<img
									src={
										isVip
											? require('@/asset/icon/vip-active.png')
											: require('@/asset/icon/vip-deactive.png')
									}
									alt=""
									className={'w-[18px] h-[16px] mt-[2px]'}
								/>
								<span className={'text-subtext ml-2'}>
									{useInfo?.packageName}
								</span>
							</div>
							<div className='text-[13px] flex items-center cursor-pointer' onClick={() => {
								setSwitchModalVisible(true);
								userinfoService.refresh() // 添加刷新团队信息
							}}>
								<SwapOutlined style={{ marginRight: '6px', marginTop: '-1px' }} />
								<p>切换<span
									className={` ${teamMode == 1 ? 'text-primary' : ''}`}
								>
									个人
								</span>/<span
									className={` ${teamMode == 2 ? 'text-primary' : ''}`}
								>
										团队
									</span></p>
							</div>
						</div>
						<Divider style={{ margin: 0 }} />
						{React.cloneElement(menu as React.ReactElement, {
							style: menuStyle
						})}
					</div>
				)}
			>
				{(() => {
					// 根据当前模式决定显示哪个头像
					const avatarPath = useInfo?.currentMode === 2
						? useInfo?.team?.avatar
						: useInfo?.avatar;
					const isTeamMode = useInfo?.currentMode === 2;

					return avatarPath ? (
						<img
							className="avatar-image cursor-pointer w-[32px] h-[32px] rounded-full block"
							src={`${BASE_URL}${avatarPath}`}
						/>
					) : (
						<Avatar
							className={'cursor-pointer bg-primary'}
							size={'default'}
							icon={isTeamMode ? <TeamOutlined /> : <UserOutlined />}
						/>
					);
				})()}
			</Dropdown >
			{messageContextHolder}
			{contextHolder}
			<ModalChangePassword
				visible={visible}
				onCancel={handleCancel}
				onOk={handleOk}
			/>
		</>
	)
}
